import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsNotificationsOff = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 19v-2h2v-7q0-.825.213-1.625T6.85 6.85L10 10H7.2L1.4 4.2l1.4-1.4 18.4 18.4-1.4 1.4-3.65-3.6zm14-3.85-9.8-9.8q.5-.4 1.075-.7T10.5 4.2v-.7q0-.625.438-1.063T12 2t1.063.438T13.5 3.5v.7q2 .5 3.25 2.113T18 10zM12 22q-.825 0-1.412-.587T10 20h4q0 .825-.587 1.413T12 22"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsNotificationsOff);
const Memo = memo(ForwardRef);
export default Memo;
